<div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
        <div class="col-lg-12">
            <div class="text-center m-t-lg">
                <h1>
                    Welcome in Inspinia Angular 10 Starter Project
                </h1>
                <small>
                    It is an application skeleton for a typical web app. You can use it to quickly bootstrap your webapp projects and dev environment.
                </small>
            </div>
        </div>
    </div>
</div>
